import { createFileRoute, Outlet } from '@tanstack/react-router'
import { navigateGuard } from '@/utils/auth'
import { UserRole } from '@/constants/user'
import React from 'react'

export const Route = createFileRoute('/_auth/smart-qc/')({
  beforeLoad: ({ location }) => {
    return navigateGuard(location, [UserRole.ADMINISTRATOR])
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  )
}
